import React, { Component } from "react";
import ModalContainer from "../modal/ModalContainer";

import { withRouter } from "react-router-dom";

import { DialogContent, IconButton } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CloseIcon from "@material-ui/icons/Close";

import "./PrivateBookingOptionModal.css";
import { ProfileType } from "../../types/enum";

@withRouter
class PrivateBookingOptionModal extends Component {
    render() {
        const { type, hidePrivateBooking, hideActBooking, hideManageAvailability } = this.props;
        const isAgent = type === ProfileType.Agent.ordinal;
        const isMusician = type === ProfileType.Musician.ordinal;
        const isStaff = type === ProfileType.Staff.ordinal;

        return (
            <ModalContainer open={this.props.open} onClose={this.props.onClose} fullScreen={false} maxWidth="md">
                <DialogContent className="booking-modal-content">
                    <IconButton className="booking-modal-close" onClick={this.props.onClose}>
                        <CloseIcon />
                    </IconButton>
                    
                    <div className="booking-modal-header">
                        <h2>Create New Booking</h2>
                        <p>Select the type of booking you want to create</p>
                    </div>

                    <div className="booking-options-container">
                        {!hidePrivateBooking && (isStaff || isAgent) && (
                            <div className="booking-option-card" onClick={this.props.handleClickVenueBooking} role="button" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && this.props.handleClickVenueBooking()}>
                                <div className="booking-option-icon">
                                    <LocationOnIcon />
                                </div>
                                <h3 className="booking-option-title">Venue Booking</h3>
                                <p className="booking-option-description">Book entertainment for a specific venue location</p>
                            </div>
                        )}

                        {!hidePrivateBooking && !hideActBooking && isMusician && (
                            <div className="booking-option-card" onClick={this.props.privateBookingHandler} role="button" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && this.props.privateBookingHandler()}>
                                <div className="booking-option-icon">
                                    <AssignmentIcon />
                                </div>
                                <h3 className="booking-option-title">Act Booking & Invoice</h3>
                                <p className="booking-option-description">For act leaders - invoice the client and schedule your players all in one</p>
                            </div>
                        )}

                        {!hidePrivateBooking && isAgent && (
                            <div className="booking-option-card" onClick={this.props.privateBookingHandler} role="button" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && this.props.privateBookingHandler()}>
                                <div className="booking-option-icon">
                                    <AssignmentIcon />
                                </div>
                                <h3 className="booking-option-title">Function Booking</h3>
                                <p className="booking-option-description">Create a private or corporate event booking</p>
                            </div>
                        )}

                        {!hidePrivateBooking && isMusician && (
                            <div className="booking-option-card" onClick={this.props.handleClickVenueBooking} role="button" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && this.props.handleClickVenueBooking()}>
                                <div className="booking-option-icon">
                                    <LocationOnIcon />
                                </div>
                                <h3 className="booking-option-title">Entertainer Booking & Invoice</h3>
                                <p className="booking-option-description">Invoice for your services - ideal when playing in another band or invoicing a band leader directly</p>
                            </div>
                        )}

                        {!hideManageAvailability && (
                            <div className="booking-option-card" onClick={this.props.privateEventHandler} role="button" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && this.props.privateEventHandler()}>
                                <div className="booking-option-icon">
                                    <AssignmentIcon />
                                </div>
                                <h3 className="booking-option-title">Manage Availability</h3>
                                <p className="booking-option-description">Update your availability calendar</p>
                            </div>
                        )}
                    </div>
                </DialogContent>
            </ModalContainer>
        );
    }
}

export default PrivateBookingOptionModal;
